<script setup>

  import { ref, onMounted } from 'vue'; 
  const props = defineProps({
    spotId: {
      type: [String, Number],
      required: true
    }
  });

  const url = ref('');

  onMounted(() => {
    url.value = `${window.location.origin}/spot/${props.spotId}`;
  });
</script>

<template>
  <a
    :href="url"
    class="jwx-block__title-action"
  >
    <slot></slot>
  </a>
</template>